// These models reflect the objects in ClearView WebPortal/App_Code/CurrentAgentStates.cs

export enum EState {
    Unknown = 0,
    Available = 1,
    Inbound = 2,
    Outbound = 4,
    Unavailable = 8,
    Custom = 16,
    Mixed = 32,
}

export interface AgentState {
    State: EState,
    DisplayState: string,
    IsACW: boolean;
}

export enum StateColor {
    Green = "#3D9649",
    Orange = "#F24813",
    Purple = "#7C52BF",
    Red = "#BD2026",
    Yellow = "#E4B321",
}

export function getStateColor(agentState: AgentState): StateColor {
    if (agentState != null) {
        if (agentState.IsACW)
            return StateColor.Orange;

        switch (agentState.State) {
            case EState.Available:
                return StateColor.Green;
            case EState.Inbound:
                return StateColor.Purple;
            case EState.Outbound:
                return StateColor.Yellow;
            case EState.Unknown:
            case EState.Unavailable:
            case EState.Custom:
            default:
                return StateColor.Red;
        }
    } else return StateColor.Red;
}

export default AgentState;
